import { render, staticRenderFns } from "./VoiceRecognition.vue?vue&type=template&id=5e172e41&scoped=true"
import script from "./VoiceRecognition.vue?vue&type=script&lang=js"
export * from "./VoiceRecognition.vue?vue&type=script&lang=js"
import style0 from "./VoiceRecognition.vue?vue&type=style&index=0&id=5e172e41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e172e41",
  null
  
)

export default component.exports